export default __webpack_public_path__ + "static/media/admin-single-course-add-bulk-users-example.e961dddf.csv";